import React, { useState } from 'react';
import Hero from '../../Assets/Hero Picture.jpg';
import Modal from '../Modal/Modal';
import ISB from '../../Assets/ISB Team.svg'
import { useTranslation } from 'react-i18next';

function HeroSection() {
  const clients = [
    { id: 1, src: ISB, alt: "logo ISB" }
  ];
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="relative">
      <img
        className="absolute inset-0  w-full h-full object-cover object-top"
        src={Hero}
        alt="hero background image"
      />
      <div className="absolute inset-0 bg-yellow-200 dark:bg-black/60 bg-opacity-30 backdrop-blur-sm"></div>
      <div className="relative container mx-auto px-6 md:px-12 lg:px-6">
        <div className="mb-12 pt-40 space-y-16 md:mb-18 md:pt-56 lg:w-8/12 lg:mx-auto">
          <h1 className="text-Eerie-Black dark:text-Ripe-mango text-center text-3xl font-bold sm:text-4xl md:text-5xl">
            {t('Header.title')}
          </h1>
          <p className='text-Eerie-Black dark:text-white text-center text-lg font-medium sm:text-base md:text-xl'>
            {t('Header.description')}
          </p>
          <p className='text-Eerie-Black dark:text-white text-center text-lg font-medium sm:text-base md:text-xl'>
            {t('Header.comingsoon')}
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-6 pb-9">
          <a
            target="blank"
            title="For Android"
            aria-label="google play"
            className="block overflow-hidden"
            onClick={() => setOpenModal(true)}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/1000px-Google_Play_Store_badge_EN.svg.png"
              className="object-cover object-top w-32 mx-auto"
              alt=""
            />
          </a>
          <a
            target="blank"
            title="For iPhone"
            aria-label="app store"
            className="block overflow-hidden"
            onClick={() => setOpenModal(true)}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Download_on_the_App_Store_Badge.svg/1000px-Download_on_the_App_Store_Badge.svg.png"
              className="object-cover object-top w-32 mx-auto"
              alt=""
            />
          </a>
          <Modal open={openModal} onClose={() => setOpenModal(false)} />
        </div>
        <div className="text-center pb-8">
          <h2 className="text-2xl pb-8 font-bold text-Eerie-Black dark:text-Ripe-mango md:text-4xl">
            {t('Header.heroText')}
          </h2>
          <div className="flex justify-center flex-wrap gap-4 px-4">
            {clients.map(client => (
              <div key={client.id} className="flex justify-center items-center group rounded-xl border border-gray-200 dark:border-Ripe-mango bg-white bg-opacity-2 py-2 px-4 hover:bg-opacity-80">
                <img
                  src={client.src}
                  className="contrast-0 transition group-hover:contrast-100"
                  alt={client.alt}
                  style={{ width: '170px', height: '150px' }}  // Adjust width and height accordingly
                />
              </div>
            ))}
          </div>
        </div>
        <Modal open={openModal} onClose={() => setOpenModal(false)} />
      </div>
    </div>
  );
}

export default HeroSection;
